import {remCalc} from '../../_utils'

export default {
    baseStyle: ({hasVisibleReview}: {hasVisibleReview: boolean}) => ({
        container: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: 0,
            alignSelf: 'stretch',
        },
        reviewWrapper: {
            mb: hasVisibleReview ? {base: remCalc(20), sm: remCalc(20), md: remCalc(20)} : 0,
            h: hasVisibleReview ? {base: remCalc(22), lg: remCalc(32)} : 0,
            alignSelf: 'flex-start',
        },
        contentWrapper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(8),
            width: '100%',
        },
        title: {
            textStyle: 'head-large',
            color: 'foreground.neutral.default',
            fontWeight: 'light',
        },
        description: {
            width: 'full',
            textStyle: 'body-small',
            color: 'foreground.neutral.muted',
            fontWeight: 'normal',
        },
        shortDescription: {
            width: '100%',
            textStyle: 'body-small',
            color: 'foreground.neutral.subtle',
            fontWeight: 'normal',
            sx: {
                '& p': {
                    m: 0,
                },
            },
        },
        shortDescriptionClamped: {
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
        },
        favSvg: {
            boxSize: 'iconsSize.medium',
            color: 'background.dark',
            strokewidthnumber: remCalc(2),
            verticalAlign: 'unset',
            p: `${remCalc(1.2)} 0 ${remCalc(0.6)} 0`,
        },
        favSvgSolid: {
            boxSize: 'iconsSize.medium',
            color: 'background.alternative',
            strokewidthnumber: remCalc(2),
            verticalAlign: 'unset',
            p: `${remCalc(1.2)} 0 ${remCalc(0.6)} 0`,
        },
        readmoreWrapper: {
            h: remCalc(24),
        },
    }),
}
